export default __webpack_public_path__ + "static/media/forestly-noexpl-05_EN.699f9924.png";